import React, { useEffect, useState, constructor } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Layout } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, TagOutlined } from '@ant-design/icons';
import { ITeacher, listTeachers, createTeacher, updateTeacher, deleteTeacher, pageTeachers } from '../../service/api/teacher';
import { IStore, listStores } from '../../service/api/store';
import { getStudent, getStudentForWechat, IStudentDetail } from '../../service/api/student';
import moment from 'moment';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { ICard, createCard } from '../../service/api/card';
import CardList from '../card/CardList';
import { Link } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;
const { Header, Footer, Sider, Content } = Layout;
const StudentDetailView = (props: any) => {
  const [studentDetails, setStudentDetails] = useState<IStudentDetail[]>();
  const [load, setLoad] = useState<Boolean>();
  const [bind, setBind] = useState<Boolean>();

  const columns = [
    {
      title: '课程类型',
      dataIndex: 'name',
      width: 60,
      key: 'name'
    },
    {
      title: '课时数',
      dataIndex: 'count',
      width: 40,
      key: 'count'
    },
    {
      title: '有效期截止',
      dataIndex: 'effectiveDate',
      width: 80,
      key: 'effectiveDate',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
      },
    }
  ];

  const columnsForRecord = [
    {
      title: '课程名',
      dataIndex: 'teachClassName',
      width: 60,
      key: 'teachClassName'
    },
    {
      title: '打卡时间',
      dataIndex: 'punchTime',
      width: 80,
      key: 'punchTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    }
  ];

  useEffect(() => {
    if (!studentDetails) {
      loadStudentDetail();
    }
  }, [studentDetails]);

  const loadStudentDetail = () => {
    const studentId = getUrlParam('studentId', window.location.href); // 获取studentId
    if (studentId == null) {
      const local = window.location.href; // 获取页面url
      const appid = 'wx558eebdb1b7158d2';
      const code = getUrlCode().code; // 截取code
      if (code == null || code === '') {
        console.log("如果没有code，则去请求")
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        console.log("有code")
        // 你自己的业务逻辑
        getStudentForWechat(code).then((info: any) => {
          if (info?.data) {
            setStudentDetails(info?.data);
            setLoad(true);
            setBind(true);
          } else {
            setLoad(true);
            setBind(false);
          }
        });
      }
    } else {
      getStudent(studentId).then((info: any) => {
        if (info?.data) {
          // 【知识点】单个对象转数组
          setStudentDetails([info?.data]);
          setLoad(true);
          setBind(true);
        } else {
          setBind(false);
        }
      });
    }
  };

  function getUrlParam(name: string, str: string) {
    try {
      const paramUrl = str.split('?');
      if (paramUrl.length >= 2) {
        const params = paramUrl[1].split('&');
        for (var i = 0; i < params.length; i++) {
          const value = params[i].split('=');
          if (value[0] == name) {
            return value[1];
          }
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
      // 在这里可以添加适当的错误处理逻辑，比如显示错误信息给用户或执行其他操作
    }
    return null;

  }

  const getUrlCode = () => {
    const url = window.location.search;
    const theRequest: { [key: string]: string } = {};
    if (url.indexOf('?') !== -1) {
      const str = url.substr(1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    return theRequest;
  };

  const loadStudent = studentDetails?.map((studentDetail: IStudentDetail) => {
    return <div>
    <Card size="small" bordered={false} >
      {/* <Layout>
      <Sider theme="light"> <img src={"https://csn-images.oss-cn-shenzhen.aliyuncs.com/markdown/20211229235440.png"} style={{ width: '50px' }}></img></Sider>
      <Sider theme="light"><p  style={{ fontSize: '16px',height:'10px', fontWeight: 'bold' }}>学员：{studentDetail?.num} {studentDetail?.name}</p></Sider>
</Layout> */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={"https://csn-images.oss-cn-shenzhen.aliyuncs.com/markdown/20211229235440.png"} style={{ width: '50px' }}></img>&nbsp;
<p style={{ fontSize: '16px', height: '10px', fontWeight: 'bold' }}>学员：{studentDetail?.num} {studentDetail?.name}</p>
      </div>
    </Card>
    {studentDetail?.courseInfo ?
      <Table dataSource={studentDetail?.courseInfo} columns={columns} pagination={false} />
      : (
        <span style={{ fontSize: '20px' }}>没有剩余课时</span>
      )}
    <Card size="small" bordered={false} >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TagOutlined />&nbsp;&nbsp; <p style={{ fontSize: '16px', height: '10px', fontWeight: 'bold' }}>近期打卡记录</p>&nbsp;&nbsp;<TagOutlined />
      </div>
    </Card>
    {studentDetail?.cardPunchRecords ?
      <Table dataSource={studentDetail?.cardPunchRecords} columns={columnsForRecord} pagination={false} />
      : (
        <span style={{ fontSize: '20px' }}>没有打卡记录</span>
      )}
  </div>
  })

  return (
    // 【知识点】在return中动态加载标签
    <div className="gutter-example">
      {load ?
        <>
          {bind ?
            <div>
            {loadStudent}
            </div>
            :
            <div>
              <span style={{ fontSize: '20px', marginLeft: '30px' }}>暂无数据，请输入手机号绑定学员～</span>
            </div>
            
          }
        </>
        :
        <>
          <span style={{ fontSize: '20px', marginLeft: '30px' }}>数据加载中...</span>
        </>
      }
    </div>
  );
};

export default StudentDetailView;
